import {ifCanPushDatalayer} from './utils/utils.dataLayer.common';

const dataLayersCareer = () => {
	const jobListingTitle = document.querySelector('.hero-job-detail .heading');
	const jobListingDepartment = document.querySelector('.hero-job-detail .department');

	if (jobListingTitle && jobListingDepartment) {
		const savedJob = () => {
			ifCanPushDatalayer({
				then: () => {
					dataLayerBus.push({
						'event': 'saved_job_listing',
						'job_listing': jobListingTitle.innerText,
						'departement': jobListingDepartment.innerText
					});
				}
			});
		};

		const unsavedJob = () => {
			ifCanPushDatalayer({
				then: () => {
					dataLayerBus.push({
						'event': 'unsaved_job_listing',
						'job_listing': jobListingTitle.innerText,
						'departement': jobListingDepartment.innerText
					});
				}
			});
		};

		return {
			savedJob,
			unsavedJob
		};
	}
};

export default dataLayersCareer;
